import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate  = useNavigate();
  const [form, setForm]     = useState({ email: "", password: "" });
  const [error, setError]   = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate("/");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "calc(100vh - 60px)",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 24,
    }}>
      <div className="card fade-up" style={{ width: "100%", maxWidth: 420, padding: 40 }}>

        <div style={{ marginBottom: 32, textAlign: "center" }}>
          <h1 style={{ fontSize: 32, marginBottom: 8 }}>歡迎回來</h1>
          <p style={{ color: "var(--muted)" }}>登入後預約你的滑雪課程</p>
        </div>

        {error && (
          <div style={{
            background: "#FEF2F2", border: "1px solid #FECACA",
            color: "var(--red)", borderRadius: 8, padding: "12px 16px",
            marginBottom: 20, fontSize: 14,
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div>
            <label style={{ display: "block", fontSize: 13, fontWeight: 500, marginBottom: 6, color: "var(--ink2)" }}>
              Email
            </label>
            <input
              className="input-field"
              type="email"
              placeholder="your@email.com"
              value={form.email}
              onChange={e => setForm({ ...form, email: e.target.value })}
              required
            />
          </div>

          <div>
            <label style={{ display: "block", fontSize: 13, fontWeight: 500, marginBottom: 6, color: "var(--ink2)" }}>
              密碼
            </label>
            <input
              className="input-field"
              type="password"
              placeholder="輸入密碼"
              value={form.password}
              onChange={e => setForm({ ...form, password: e.target.value })}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-full"
            style={{ marginTop: 8, height: 48 }}
            disabled={loading}
          >
            {loading ? <span className="spinner" style={{ borderTopColor: "var(--white)" }} /> : "登入"}
          </button>
        </form>

        <p style={{ textAlign: "center", marginTop: 24, color: "var(--muted)", fontSize: 14 }}>
          還沒有帳號？{" "}
          <Link to="/register" style={{ color: "var(--ink)", fontWeight: 500, textDecoration: "underline" }}>
            立即註冊
          </Link>
        </p>
      </div>
    </div>
  );
}